import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React, { Component, Children, cloneElement, createRef } from "react";
var modes = {
  VERTICAL: 1,
  HORIZONTAL: 2,
  BOTH: 3
};

var ChildrenLength = function ChildrenLength(children) {
  return Children.toArray(children).filter(function (c) {
    return c && typeof c === "object";
  }).length;
};

var ArrowNav =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(ArrowNav, _Component);

  function ArrowNav() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.innerRef = createRef();
    _this.state = {
      active: 0
    };

    _this.onClick = function (e) {
      if (_this.innerRef.current && e.target !== e.currentTarget) {
        var clickOrigin = Array.from(_this.innerRef.current.children).findIndex(function (c) {
          return c.contains(e.target);
        });
        if (clickOrigin > -1) _this.setState({
          active: clickOrigin
        });
      }

      if (_this.props.onClick) _this.props.onClick(e);
    };

    _this.handler = function (e) {
      var childCount = ChildrenLength(_this.props.children);
      if (!childCount) return;
      var mode = _this.props.mode;

      switch (e.key) {
        case "ArrowUp":
          if (mode === modes.BOTH || mode === modes.VERTICAL) {
            e.preventDefault();

            _this.setState(function (_ref) {
              var active = _ref.active;
              return {
                active: (active - 1 + childCount) % childCount
              };
            });
          }

          break;

        case "ArrowDown":
          if (mode === modes.BOTH || mode === modes.VERTICAL) {
            e.preventDefault();

            _this.setState(function (_ref2) {
              var active = _ref2.active;
              return {
                active: (active + 1) % childCount
              };
            });
          }

          break;

        case "ArrowLeft":
          if (mode === modes.BOTH || mode === modes.HORIZONTAL) {
            e.preventDefault();

            _this.setState(function (_ref3) {
              var active = _ref3.active;
              return {
                active: (active - 1 + childCount) % childCount
              };
            });
          }

          break;

        case "ArrowRight":
          if (mode === modes.BOTH || mode === modes.HORIZONTAL) {
            e.preventDefault();

            _this.setState(function (_ref4) {
              var active = _ref4.active;
              return {
                active: (active + 1) % childCount
              };
            });
          }

          break;

        default:
          break;
      }
    };

    return _this;
  }

  var _proto = ArrowNav.prototype;

  _proto.renderChildren = function renderChildren() {
    var children = this.props.children;
    var active = this.state.active;
    var index = -1;
    return Children.map(children, function (child) {
      if (!child) return null;
      if (typeof child !== "object") return child;
      index++;
      return cloneElement(child, {
        tabIndex: active === index ? Math.max(0, child.props.tabIndex || 0) : Math.min(-1, child.props.tabIndex || 0)
      });
    });
  };

  _proto.componentDidUpdate = function componentDidUpdate(_, _ref5) {
    var prevActive = _ref5.active;
    var active = this.state.active;
    if (prevActive !== active) if (this.innerRef.current && this.innerRef.current.childElementCount > active) this.innerRef.current.children[active].focus();
  };

  _proto.render = function render() {
    var _this$props = this.props,
        mode = _this$props.mode,
        rest = _objectWithoutPropertiesLoose(_this$props, ["mode"]);

    return React.createElement("div", _extends({}, rest, {
      onClick: this.onClick,
      ref: this.innerRef,
      onKeyDown: this.handler
    }), this.renderChildren());
  };

  return ArrowNav;
}(Component);

ArrowNav.mode = modes;
ArrowNav.defaultProps = {
  mode: modes.VERTICAL
};
export default ArrowNav;